import { jsx } from 'react/jsx-runtime';
import { StripeProvider } from '@sketch/components';
import config from '@sketch/env-config';

const StripeProviderWrapper = ({ children }) => (jsx(StripeProvider, Object.assign({ stripeKey: config['stripe_api_key'] }, { children: children })));

export { StripeProviderWrapper as StripeProvider };
